import React, {useEffect, useState} from 'react';
import VideoInstruction from "../VideoInstruction";
import {FormattedMessage} from "react-intl";
import apiClient from "utils/apiClient";
import { Button } from 'ui';
import '../InstructionButton/styles.scss';
import { useLocaleContext } from 'context/LocaleContext';

const LoginInstructionButton: React.FC<any> = ({}) => {
    const { locale } = useLocaleContext();
    const [showVideoInstructionModal, setShowVideoInstructionModal] = useState(false);
    const [code, setCode] = useState();

    useEffect(() => {
        const loadInstruction = async () => {
            try {
                let url = `/api/v1/login-help/${locale}`

                const response = await apiClient.request(url, {}, 'GET');

                if (response.code.length) {
                    setCode(response.code[0].code);
                }
            } catch (error) {
                console.error(error);
            }
        };

        loadInstruction();

    }, [locale]);

    return (
        <>
            {!!code ?
                <>
                    <div className='login-help' onClick={() => setShowVideoInstructionModal(true)}>
                        {/* mock button */}
                        <FormattedMessage id="general.login_problems"/>
                        <Button className='help-button-login' icon='fas fa-play' message=' '/>
                    </div>
                    <VideoInstruction
                        visible={showVideoInstructionModal}
                        onCancel={() => setShowVideoInstructionModal(false)}
                        videoCode={code}
                        reset={false}
                        setCode={setCode}
                    />
                </>
                : null
            }
        </>
    )
};

export default LoginInstructionButton;
